const EVENTS = {
  MOUSE_WHEEL: "viewport-mouse-wheel",
  MOUSE_CLICK: "event-mouse-click",
  MOUSE_DOWN: "event-mouse-down",
  MOUSE_DOWN_ACTIVATE: "event-mouse-down-activate",
  MOUSE_DOUBLE_CLICK: "event-mouse-double-click",
  MOUSE_DRAG: "event-mouse-drag",
  MOUSE_MOVE: "event-mouse-move",
  MOUSE_UP: "event-mouse-up",

  IMAGE_RENDERED: "image-rendered",
  MEASUREMENT_MODIFIED: "measurement-modified",
  ELEMENT_DISABLED: "elementdisabled",
  ELEMENT_ENABLED: "elementenabled",

  SCROLL_INDEX_CHANGED: "scroll-index-changed",
  PAN_ZOOM_CHANGED: "pan-zoom-changed",
  WWWC_CHANGED: "wwwc-changed",
  WWWC_CHANGING: "wwwc-changing",

  NEW_IMAGE: "new-image",
};

export default EVENTS;
